import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=f0d05f3e&"
import script from "./ButtonToggle.vue?vue&type=script&lang=ts&"
export * from "./ButtonToggle.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
